import { registerQuery, useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import InnerSection from 'marketplace-ui-common/layout/components/InnerSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { isSucceeded } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import { DetailMainSection as MainSection } from 'ecosystem-marketplace-core/components/layout/MainSection';
import MainSectionHeading from 'ecosystem-marketplace-core/components/layout/MainSectionHeading';
import { marketplaceAppSearch } from '../../clients/marketplaceSearchClient';
import * as FilterKey from '../../constants/search/FilterKey';
import * as SortField from '../../constants/search/SortField';
import ResultsGrid from '../storefront/results/ResultsGrid';
import { useAppContext } from '../../context/AppContext';
// @ts-expect-error untyped import
import StorefrontFilters from '../../records/StorefrontFilters';
import { getCategoryFilterUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GET_MORE_APPS = registerQuery({
  fieldName: 'moreApps',
  args: ['language', 'category', 'slug', 'appContext'],
  fetcher: ({
    language,
    category,
    slug,
    appContext
  }) => {
    const queries = [new StorefrontFilters().merge({
      [FilterKey.CATEGORY]: category,
      [FilterKey.SORT_FIELD]: SortField.RANDOM
    }).toSearchQuery({
      length: 4,
      nextSearchMaxTrigger: 0
    })];
    return marketplaceAppSearch({
      appContext
    }, {
      language,
      queries,
      showPreferredLanguageFirst: true
    }).then(resp => {
      const results = resp.results[0].items.filter(({
        slug: _slug
      }) => _slug !== slug);
      if (results.length > 3) {
        results.pop();
      }
      return results;
    });
  }
});
const MoreApps = ({
  category,
  superCategory,
  slug,
  trackInteraction
}) => {
  const language = getLang();
  const appContext = useAppContext();
  const {
    data: moreAppsData,
    error: moreAppsError,
    loading: moreAppsLoading
  } = useQuery(GET_MORE_APPS, {
    variables: {
      language,
      category,
      slug,
      appContext
    }
  });
  const moreAppsRequestState = getDataFetchingClientRequestState(moreAppsError, moreAppsLoading);
  const moreAppsResults = isSucceeded(moreAppsRequestState) ? moreAppsData === null || moreAppsData === void 0 ? void 0 : moreAppsData.moreApps : [];
  return moreAppsResults.length && /*#__PURE__*/_jsx(MainSection, {
    color: "light",
    children: /*#__PURE__*/_jsxs(MainSectionInner, {
      children: [/*#__PURE__*/_jsx(MainSectionHeading, {
        itemRight: /*#__PURE__*/_jsx(UIRouterLink, {
          onClick: () => {
            trackInteraction('click more apps see all link', {
              section: 'more apps'
            });
          },
          to: getCategoryFilterUrl(category, superCategory),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "appMarketplace.detail.moreApps.seeAllLinkText"
          })
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.moreApps.headingText",
          options: {
            category: unescapedText(getCategoryI18nKey(category))
          }
        })
      }), /*#__PURE__*/_jsx(InnerSection, {
        children: /*#__PURE__*/_jsx(ResultsGrid, {
          className: "vr-hidden",
          onResultClick: () => {
            trackInteraction('click more apps result item', {
              section: 'more apps'
            });
          },
          requestState: moreAppsRequestState,
          results: moreAppsResults,
          resultProps: {
            superCategory
          }
        })
      })]
    })
  });
};
export default MoreApps;